import Loadable from '../../components/loadable';

const WizardStepper = Loadable({
  loader: () => import('../../components/wizard_stepper'),
});

angular.module('shared').value('WizardStepper', WizardStepper);
